export default __webpack_public_path__ + "static/media/home-cafe-bg-img-02.b4f15acf.jpg";